import { PermissionsList } from '@modules/permissions/constants';
import { Permission } from '@modules/permissions/utils';

export const TRANSLATION_GROUP_PENDING_WITHDRAWALS = Symbol('pending-withdrawals');

export const ADMIN_PENDING_WITHDRAWALS_ROUTE_NAME = Symbol('admin.pending-withdrawals');
export const ADMIN_PENDING_WITHDRAWALS_LIST_ROUTE_NAME = Symbol('admin.pending-withdrawals.list');

export const PENDING_WITHDRAWALS_LIST_API_URL = 'admin/affiliate_cashouts/pending_cashouts/list';
export const PENDING_WITHDRAWALS_DOWNLOAD_REPORT_URL = 'admin/affiliate_cashouts/pending_cashouts/download_report';
export const PENDING_WITHDRAWALS_LIST_QUERY_KEY = 'pending-withdrawals.list';
export const PENDING_WITHDRAWALS_DOWNLOAD_REPORT_MUTATION_KEY = 'pending-withdrawals.download-report';

export const PENDING_WITHDRAWALS_ACCEPT_URL = 'admin/affiliate_cashouts/pending_cashouts/:id/approve';
export const PENDING_WITHDRAWALS_ACCEPT_MUTATION_KEY = 'pending-withdrawals.accept';

export const PENDING_WITHDRAWALS_DENY_URL = 'admin/affiliate_cashouts/pending_cashouts/:id/decline';
export const PENDING_WITHDRAWALS_DENY_MUTATION_KEY = 'pending-withdrawals.deny';

export const PENDING_WITHDRAWALS_PERMISSIONS = {
  SHOW: new Permission(PermissionsList.admin.AFFILIATECASHOUTS_PENDING_WITHDRAWALS_SHOW),
  DOWNLOAD_LIST: new Permission(PermissionsList.admin.AFFILIATECASHOUTS_PENDING_WITHDRAWALS_DOWNLOAD),
  EDIT: new Permission(PermissionsList.admin.AFFILIATECASHOUTS_PENDING_WITHDRAWALS_EDIT),
};
